<div class="p-0 container banner-container">
  <img class="d-none d-md-block banner" [src]="banner?.imageUrl" />
  <div class="milestone-container">
    <div class="milestone-body">
      <img [src]="milestoneBarImage" />
      <div class="milestone-title" [innerHTML]="banner?.title"></div>
      <div class="progress-bar" [style.width.px]="barWidth"></div>
    </div>
  </div>
</div>
